import axios from 'axios';
import { Box } from '@amzn/awsui-components-react';
import base64url from 'base64url';
import React from 'react';
import { withCookies } from 'react-cookie';
import { Redirect } from 'react-router';
import {
  Alert,
  Button,
  ColumnLayout,
  Icon,
  Spinner,
} from '@amzn/awsui-components-react';
import {
  API_ENDPOINT,
  ERROR_MESSAGE_SERVICE_API_ERROR,
  ERROR_MESSAGE_THROTTLED_REQUEST,
  HAS_MUTUAL_AUTH_COOKIE,
  IS_SAML_AUTH_COOKIE,
  IS_SAML_LOGOUT_COOKIE,
  SESSION_TOKEN_COOKIE,
} from '../../constants';
import AdAuthForm from '../AdAuthForm';

class EndpointHome extends React.Component {
  constructor(props) {
    super(props);
    this.endpointId = this.props.match.params.endpointId;
    this.onClickDownloadConfiguration = this.onClickDownloadConfiguration.bind(
      this,
    );
    this.onClickDownloadApp = this.onClickDownloadApp.bind(this);
    this.onClickLogout = this.onClickLogout.bind(this);
    this.onErrorAlertDismiss = this.onErrorAlertDismiss.bind(this);
    this.onMutualAuthAlertDismiss = this.onMutualAuthAlertDismiss.bind(this);

    const session = this.initializeSession();
    this.state = {
      adAuth: null,
      clientAppMetadata: null,
      configDownloadInProgress: false,
      errorMessage: null,
      loading: true,
      session: session,
      mutualAuthAlertDismissed: false,
    };
  }

  render() {
    if (this.state.loading === true) {
      return (
        <div className="custom-spinner">
          <Spinner size="large"></Spinner>
        </div>
      );
    }

    if (this.state.errorMessage !== null) {
      return (
        <Alert
          type="error"
          visible={!!this.state.errorMessage}
          onDismiss={this.onErrorAlertDismiss}
        >
          {this.state.errorMessage}
        </Alert>
      );
    }

    if (this.state.session === null) {
      if (this.state.adAuth !== null) {
        return (
          <AdAuthForm endpointId={this.endpointId} adAuth={this.state.adAuth} />
        );
      } else {
        return null;
      }
    }

    if (this.state.session.cvpn !== this.endpointId) {
      this.removeSessionCookie();
      return <Redirect to="/" />;
    }

    const hasMutualAuth =
      this.props.cookies.get(HAS_MUTUAL_AUTH_COOKIE) === 'true';
    const mutualAuthAlertClassName = `awsui-util-mh-l ${
      hasMutualAuth ? '' : 'awsui-util-d-n'
    }`;
    return (
      <>
        <div className="logout-container awsui-util-container container-no-border max-width-container">
          <Box fontSize="heading-xs" float="right">
            <Button iconName="lock-private" onClick={this.onClickLogout}>
              Log out
            </Button>
          </Box>
        </div>
        <Box
          /// Keeping margin as zero
          className="awsui-util-container awsui-util-no-gutters container-no-border max-width-container"
        >
          {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
          {/* POLARIS_V3.0_MIGRATION_WARNING: Replace this Box component with the Header component if the heading is in the Header of a Form, Table, Container or FormSection. */}

          <Box
            variant="h2"
            //margin={{ top: 'xxl', bottom: 'xs' }}
            fontSize="heading-xs"
          >
            <div backgroundColor="white" style={{ color: '#FFFFFF' }}>
              Download the VPN client configuration file for the endpoint
            </div>
          </Box>
          {/* Config Start  starting box*/}
          <Box>
            <div
              //className="awsui-util-container client-config-container"
              style={{
                backgroundColor: 'white',
                width: '400px',
                height: '146px',
                borderRadius: '5px',
                margin: '10px',
              }}
            >
              <Box
                margin={{ top: 'l', horizontal: 'l' }}
                color="inherit"
                fontSize="body-s"
              >
                <i>Endpoint ID</i>
              </Box>
              <Box
                margin={{ horizontal: 'l', bottom: 'l' }}
                fontSize="heading-m"
              >
                {this.endpointId}
              </Box>
              <div className={mutualAuthAlertClassName}>
                <Box margin={{ horizontal: 'l' }}>
                  <Alert
                    visible={
                      hasMutualAuth && !this.state.mutualAuthAlertDismissed
                    }
                    onDismiss={this.onMutualAuthAlertDismiss}
                  >
                    This endpoint uses mutual authentication, hence you might
                    need to update the configuration file with the client
                    certificate and key after downloading it. Please reach out
                    to your IT administrator for detailed instructions to update
                    the VPN profile.
                  </Alert>
                </Box>
              </div>
              <Box margin={{ vertical: 'l', horizontal: 'l' }}>
                <Button
                  onClick={this.onClickDownloadConfiguration}
                  variant="primary"
                >
                  {this.state.configDownloadInProgress ? (
                    <Spinner></Spinner>
                  ) : (
                    <>
                      <Icon name="download"></Icon> Download client
                      configuration
                    </>
                  )}
                </Button>
              </Box>
            </div>
          </Box>
          {/* Config end ending box*/}
        </Box>
        <Box
          margin={{ top: 'xxl' }}
          className="awsui-util-container awsui-util-no-gutters container-no-border max-width-container"
        >
          {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
          {/* POLARIS_V3.0_MIGRATION_WARNING: Replace this Box component with the Header component if the heading is in the Header of a Form, Table, Container or FormSection. */}
          <Box
            variant="h2"
            margin={{ top: 'xxl', bottom: 'xs' }}
            fontSize="heading-xs"
          >
            Download the AWS Client VPN app for desktop
          </Box>

          {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
          <Box margin={{ top: 'l' }}>
            {/* Updated from 3 to 5 columns to accommodate ARM64 download cards */}
            <ColumnLayout columns={5}>
              {/* Windows Start  starting box*/}

              <div
                style={{
                  backgroundColor: 'white',
                  padding: '20px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                }}
              >
                <Box
                  margin={{ right: 'xxl' }}
                  className="awsui-util-container app-container windows-app-container awsui-util-no-gutters"
                >
                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box
                    margin={{ top: 'xs', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>VPN Client</i>
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  {/* POLARIS_V3.0_MIGRATION_WARNING: Replace this Box component with the Header component if the heading is in the Header of a Form, Table, Container or FormSection. */}
                  <Box
                    variant="h3"
                    margin={{ horizontal: 's', bottom: 'l' }}
                    fontSize="heading-m"
                    id="windows-header"
                  >
                    AWS Client VPN for Windows
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box
                    margin={{ top: 'l', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      Version:{' '}
                      {this.state.clientAppMetadata.Windows.ApplicationVersion}
                    </i>
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box
                    margin={{ horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      File size:{' '}
                      {this.formatBytes(
                        this.state.clientAppMetadata.Windows.FileSizeInBytes,
                      )}
                    </i>
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box margin={{ top: 'l', bottom: 'xs', horizontal: 's' }}>
                    <Button
                      id="download-button-windows"
                      aria-labelledby="download-button-windows-header"
                      onClick={() => this.onClickDownloadApp('Windows')}
                      variant="primary"
                    >
                      <Icon name="download"></Icon> Download
                    </Button>
                  </Box>
                </Box>
              </div>
              {/* Windows end ending box*/}

              {/*  MacOS start starting box */}
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '20px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                }}
              >
                <Box
                  margin={{ right: 'xxl' }}
                  className="awsui-util-container app-container osx-app-container awsui-util-no-gutters"
                >
                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box
                    margin={{ top: 'xs', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>VPN Client</i>
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  {/* POLARIS_V3.0_MIGRATION_WARNING: Replace this Box component with the Header component if the heading is in the Header of a Form, Table, Container or FormSection. */}
                  <Box
                    variant="h3"
                    margin={{ horizontal: 's', bottom: 'l' }}
                    fontSize="heading-m"
                    id="osx-header"
                  >
                    AWS Client VPN for macOS
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box
                    margin={{ top: 'l', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      Version:{' '}
                      {this.state.clientAppMetadata.OSX.ApplicationVersion}
                    </i>
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box
                    margin={{ horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      File size:{' '}
                      {this.formatBytes(
                        this.state.clientAppMetadata.OSX.FileSizeInBytes,
                      )}
                    </i>
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box margin={{ vertical: 'l', horizontal: 's' }}>
                    <Button
                      id="download-button-osx"
                      aria-labelledby="download-button-osx-header"
                      onClick={() => this.onClickDownloadApp('OSX')}
                      variant="primary"
                    >
                      <Icon name="download"></Icon> Download
                    </Button>
                  </Box>
                </Box>
              </div>
              {/*  OSX end ending box*/}

              {/*  Linux start starting box*/}
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '20px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                }}
              >
                <Box
                  margin={{ right: 'xxl' }}
                  className="awsui-util-container app-container linux-app-container awsui-util-no-gutters"
                >
                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box
                    margin={{ top: 'xs', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>VPN Client</i>
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  {/* POLARIS_V3.0_MIGRATION_WARNING: Replace this Box component with the Header component if the heading is in the Header of a Form, Table, Container or FormSection. */}
                  <Box
                    variant="h3"
                    margin={{ horizontal: 's', bottom: 'l' }}
                    fontSize="heading-m"
                    id="linux-header"
                  >
                    AWS Client VPN for Linux
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box
                    margin={{ top: 'l', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      Version:{' '}
                      {this.state.clientAppMetadata.Linux.ApplicationVersion}
                    </i>
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box
                    margin={{ horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      File size:{' '}
                      {this.formatBytes(
                        this.state.clientAppMetadata.Linux.FileSizeInBytes,
                      )}
                    </i>
                  </Box>

                  {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
                  <Box margin={{ vertical: 'l', horizontal: 's' }}>
                    <Button
                      id="download-button-linux"
                      aria-labelledby="download-button-linux-header"
                      onClick={() => this.onClickDownloadApp('Linux')}
                      variant="primary"
                    >
                      <Icon name="download"></Icon> Download
                    </Button>
                  </Box>
                </Box>
              </div>

              {/* Linux end end box */}

              {/* Windows ARM64 start - ARM64 download card for Windows on ARM devices (e.g. Surface Pro X, Snapdragon laptops) */}
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '20px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                }}
              >
                <Box
                  margin={{ right: 'xxl' }}
                  className="awsui-util-container app-container windows-arm64-app-container awsui-util-no-gutters"
                >
                  <Box
                    margin={{ top: 'xs', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>VPN Client</i>
                  </Box>
                  <Box
                    variant="h3"
                    margin={{ horizontal: 's', bottom: 'l' }}
                    fontSize="heading-m"
                    id="windows-arm64-header"
                  >
                    AWS Client VPN for Windows (ARM64)
                  </Box>
                  <Box
                    margin={{ top: 'l', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      Version:{' '}
                      {
                        this.state.clientAppMetadata.WindowsARM64
                          .ApplicationVersion
                      }
                    </i>
                  </Box>
                  <Box
                    margin={{ horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      File size:{' '}
                      {this.formatBytes(
                        this.state.clientAppMetadata.WindowsARM64
                          .FileSizeInBytes,
                      )}
                    </i>
                  </Box>
                  <Box margin={{ top: 'l', bottom: 'xs', horizontal: 's' }}>
                    <Button
                      id="download-button-windows-arm64"
                      aria-labelledby="download-button-windows-arm64-header"
                      onClick={() => this.onClickDownloadApp('WindowsARM64')}
                      variant="primary"
                    >
                      <Icon name="download"></Icon> Download
                    </Button>
                  </Box>
                </Box>
              </div>
              {/* Windows ARM64 end */}

              {/* OSX ARM64 start - ARM64 download card for macOS on Apple Silicon (M1/M2/M3/M4 Macs) */}
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '20px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                }}
              >
                <Box
                  margin={{ right: 'xxl' }}
                  className="awsui-util-container app-container osx-arm64-app-container awsui-util-no-gutters"
                >
                  <Box
                    margin={{ top: 'xs', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>VPN Client</i>
                  </Box>
                  <Box
                    variant="h3"
                    margin={{ horizontal: 's', bottom: 'l' }}
                    fontSize="heading-m"
                    id="osx-arm64-header"
                  >
                    AWS Client VPN for macOS (ARM64)
                  </Box>
                  <Box
                    margin={{ top: 'l', horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      Version:{' '}
                      {this.state.clientAppMetadata.OSXARM64.ApplicationVersion}
                    </i>
                  </Box>
                  <Box
                    margin={{ horizontal: 's' }}
                    color="text-body-secondary"
                    fontSize="body-s"
                  >
                    <i>
                      File size:{' '}
                      {this.formatBytes(
                        this.state.clientAppMetadata.OSXARM64.FileSizeInBytes,
                      )}
                    </i>
                  </Box>
                  <Box margin={{ vertical: 'l', horizontal: 's' }}>
                    <Button
                      id="download-button-osx-arm64"
                      aria-labelledby="download-button-osx-arm64-header"
                      onClick={() => this.onClickDownloadApp('OSXARM64')}
                      variant="primary"
                    >
                      <Icon name="download"></Icon> Download
                    </Button>
                  </Box>
                </Box>
              </div>
              {/* OSX ARM64 end */}
            </ColumnLayout>
          </Box>
        </Box>
        <Box
          margin={{ top: 'xxl' }}
          className="awsui-util-container awsui-util-no-gutters container-no-border max-width-container"
        >
          For help getting started with AWS Client VPN, please visit the{' '}
          <a
            href="https://docs.aws.amazon.com/vpn/latest/clientvpn-user/client-vpn-user-what-is.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            documentation
          </a>
          .
        </Box>
        <Box
          margin={{ top: 'xxl' }}
          className="awsui-util-container awsui-util-no-gutters container-no-border max-width-container"
        >
          By downloading the software client for AWS Client VPN, you agree to
          the AWS customer agreement, AWS service terms, and AWS privacy notice.
          If you already have an AWS customer agreement, you agree that the
          terms of that agreement govern your download and use of this product.
        </Box>
      </>
    );
  }

  componentDidMount() {
    if (this.state.session === null) {
      this.getEndpointAuthenticationType();
    } else {
      this.getClientAppMetadata();
    }
  }

  initializeSession() {
    const sessionToken = this.props.cookies.get(SESSION_TOKEN_COOKIE);
    if (sessionToken === undefined) {
      return null;
    }

    if (process.env.REACT_APP_ENV === 'local') {
      return {
        cvpn: sessionToken,
      };
    }

    try {
      const jwtPayload = sessionToken.split('.')[1];
      return JSON.parse(base64url.decode(jwtPayload));
    } catch (e) {
      return null;
    }
  }

  removeSessionCookie() {
    this.props.cookies.remove(SESSION_TOKEN_COOKIE, {
      path: '/',
      secure: true,
    });
    this.props.cookies.remove(IS_SAML_AUTH_COOKIE, {
      path: '/',
      secure: true,
    });
  }

  getEndpointAuthenticationType() {
    this.setState({
      loading: true,
    });

    axios({
      method: 'get',
      url: `${API_ENDPOINT}/endpoints/${this.endpointId}/authentication-type`,
    })
      .then((response) => {
        this.handleAuthenticationTypeResponse(response);
      })
      .catch((error) => {
        console.log(error.response);
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data['Message']) ||
          ERROR_MESSAGE_SERVICE_API_ERROR;
        this.setState({
          errorMessage: errorMessage,
          loading: false,
        });
      });
  }

  handleAuthenticationTypeResponse(response) {
    const data = response.data;
    switch (data.AuthenticationType) {
      case 'SAML':
        this.handleSamlAuthenticationType(data);
        break;
      case 'AD':
        this.handleAdAuthenticationType(data, false);
        break;
      case 'AD_WITH_MFA':
        this.handleAdAuthenticationType(data, true);
        break;
      default:
        break;
    }
  }

  handleSamlAuthenticationType(data) {
    if (data.Location !== undefined) {
      window.location.href = data.Location;
    }
  }

  handleAdAuthenticationType(data, mfaEnabled) {
    this.setState({
      loading: false,
      adAuth: {
        mfaEnabled: mfaEnabled,
      },
    });
  }

  getClientAppMetadata() {
    this.setState({
      loading: true,
    });

    axios({
      method: 'get',
      url: `${API_ENDPOINT}/endpoints/${this.endpointId}/app`,
      withCredentials: true,
    })
      .then((response) => {
        this.setState({
          clientAppMetadata: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error.response);
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data['Message']) ||
          ERROR_MESSAGE_SERVICE_API_ERROR;
        const statusCode = (error.response && error.response.status) || 500;
        this.setState({
          errorMessage:
            statusCode === 403 ? ERROR_MESSAGE_THROTTLED_REQUEST : errorMessage,
          loading: false,
        });
      });
  }

  onClickDownloadConfiguration() {
    this.setState({
      configDownloadInProgress: true,
    });

    axios({
      method: 'get',
      url: `${API_ENDPOINT}/endpoints/${this.endpointId}/configuration`,
      withCredentials: true,
    })
      .then((response) => {
        this.setState({
          configDownloadInProgress: false,
        });
        this.downloadContentAsFile(
          response.data['ClientConfiguration'],
          `${this.endpointId}.ovpn`,
        );
      })
      .catch((error) => {
        console.log(error.response);
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data['Message']) ||
          ERROR_MESSAGE_SERVICE_API_ERROR;
        const statusCode = (error.response && error.response.status) || 500;
        this.setState({
          configDownloadInProgress: false,
          errorMessage:
            statusCode === 403 ? ERROR_MESSAGE_THROTTLED_REQUEST : errorMessage,
        });
      });
  }

  onClickDownloadApp(platform) {
    this.downloadUrlAsFile(
      this.state.clientAppMetadata[platform].DownloadURL,
      platform.toLowerCase(),
    );
  }

  onErrorAlertDismiss() {
    this.setState({ errorMessage: null });
  }

  onMutualAuthAlertDismiss() {
    this.setState({ mutualAuthAlertDismissed: true });
  }

  onClickLogout() {
    const isSamlAuth = this.props.cookies.get(IS_SAML_AUTH_COOKIE) === 'true';
    this.props.cookies.set(IS_SAML_LOGOUT_COOKIE, isSamlAuth, {
      path: '/',
      secure: true,
      maxAge: 60,
    });
    this.removeSessionCookie();
    window.location.href = '/';
  }

  downloadContentAsFile(content, filename) {
    var element = document.createElement('a');
    element.setAttribute(
      'href',
      'data:text/plain;charset=utf-8,' + encodeURIComponent(content),
    );
    element.setAttribute('download', filename);

    // Above code is equivalent to
    // <a href="path of file" download="file name">

    document.body.appendChild(element);
    // trigger onClick event
    element.click();
    document.body.removeChild(element);
  }

  downloadUrlAsFile(url, className) {
    var element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('class', className);
    document.body.appendChild(element);
    if (window.Cypress) {
      // Do not attempt to actually download the file in test.
      // Just leave the anchor in there.
      return;
    }
    // trigger onClick event
    element.click();
    document.body.removeChild(element);
  }

  formatBytes(bytes, decimals = 2) {
    // source: https://stackoverflow.com/a/18650828
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}

export default withCookies(EndpointHome);
